import { Box, TableCell, TableRow, Typography, TableContainer, TableHead, TableBody, Paper, Table, Snackbar, Alert, Button, TablePagination, Divider } from "@mui/material";
import { colors } from "../../../../theme/muiColors";
import { useEffect, useState } from "react";
import { getSuppliesProvidersId } from "../helpers/getSuppliesProvidersId";
import { AddSupplyXProvider } from "./AddSupplyXProvider";
import { EditSupplyXProvider } from "./EditSupplyXProvider";
import { deleteSupplyProvider } from "../helpers/deleteSupplyProvider";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import { BaseModalComponent } from "../../../common/BaseModalComponent";
import { IconButtonComponent } from "../../../common/IconButtonComponent";
import { Add } from "@mui/icons-material";
import { ConfirmDialog } from "../../../common/ConfirmDialog";

export const MergeSupplieProvider = ({ provider }) => {
  const [suppliesProvider, setSuppliesProvider] = useState([]);
  const token = sessionStorage.getItem("token");
  const [pageChild, setPageChild] = useState(0);
  const [pageSizeChild, setPageSizeChild] = useState(8);
  const [totalItems, setTotalItems] = useState(0);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [selectedSupply, setSelectedSupply] = useState(null);

  const [openConfirm, setOpenConfirm] = useState(false);
  const [pendingDeleteId, setPendingDeleteId] = useState(null);

  useEffect(() => {
    const fetchSupplies = async () => {
      try {
        const resSP = await getSuppliesProvidersId({
          token,
          id: provider.id,
          page: pageChild + 1,
          pageSize: pageSizeChild,
        });
        setSuppliesProvider(resSP.data.items || []);
        setTotalItems(parseInt(resSP.data.totalItems));
      } catch (error) {
        console.log(error);
      }
    };
    fetchSupplies();
  }, [openSnackbar, provider.id, pageChild, pageSizeChild]);

  const handleDelete = async (supplyId) => {
    try {
      await deleteSupplyProvider({ token, id: supplyId });

      if (suppliesProvider.length === 1 && pageChild > 0) {
        setPageChild((prev) => prev - 1);
      }

      setSnackbarMessage("Supply deleted successfully!");
      setOpenSnackbar(true);
    } catch (error) {
      console.error("Error deleting supply:", error);
    }
  };

  const handleEdit = (supply) => {
    setSelectedSupply(supply);
  };

  // Cerrar modal editar
  const handleCloseEditModal = () => {
    setSelectedSupply(null);
  };

  const Row = ({ data }) => (
    <TableRow
      sx={{ "& > *": { borderBottom: "unset" }, wordBreak: "break-word" }}
      hover
    >
      <TableCell>{data.name}</TableCell>
      <TableCell>
        <Button
          variant="outlined"
          size="small"
          sx={{ mr: 1 }}
          onClick={() => {
            setPendingDeleteId(data.id);
            setOpenConfirm(true);
          }}
        >
          Delete
        </Button>

        <BaseModalComponent
          modalKey={`edit-supply-${data.id}`}
          modalLabel="Edit Supply"
          elementTrigger={
            <Button variant="outlined" size="small">
              Edit
            </Button>
          }
        >
          <EditSupplyXProvider
            modalKey={`edit-supply-${data.id}`}
            supply={data}
            onSuccess={() => {
              setSnackbarMessage("Supply updated successfully!");
              setOpenSnackbar(true);
            }}
            onClose={handleCloseEditModal}
          />
        </BaseModalComponent>
      </TableCell>
    </TableRow>
  );

  return (
    <>
      <Box sx={{ width: "100%", overflowX: "auto", mt: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
          <Inventory2OutlinedIcon color="primary" />
          <Box>
            <Typography variant="h5" sx={{ fontWeight: "bold" }}>
              Supplies for {provider.name}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Manage all supplies linked to this provider
            </Typography>
          </Box>

          <BaseModalComponent
            modalKey={`add-supply`}
            modalLabel="Add Supply"
            elementTrigger={
              <IconButtonComponent
                sx={{ color: "#fff", backgroundColor: colors.blue[300] }}
              >
                <Add />
              </IconButtonComponent>
            }
          >
            <AddSupplyXProvider
              modalKey={`add-supply`}
              idProvider={provider.id}
              onSuccess={() => {
                setSnackbarMessage("Supply added successfully!");
                setOpenSnackbar(true);
              }}
              onClose={() => { }}
            />
          </BaseModalComponent>
        </Box>

        <Divider sx={{ mb: 2 }} />

        {suppliesProvider.length === 0 ? (
          <Box
            sx={{
              mt: 4,
              p: 4,
              border: "2px dashed var(--fx-surface-borderstrong, #CBD5E1)",
              borderRadius: 2,
              textAlign: "center",
              color: "var(--fx-surface-textsecondary, #64748B)",
              backgroundColor: "var(--fx-surface-sunken, #F8FAFC)",
            }}
          >
            <Typography variant="h6" gutterBottom>
              No supplies found
            </Typography>
            <Typography variant="body1">
              Add supplies to your provider to see them here.
            </Typography>
          </Box>
        ) : (
          <>
            <TableContainer
              component={Paper}
              sx={{ width: "100%", overflowX: "auto" }}
            >
              <Table size="medium">
                <TableHead>
                  <TableRow sx={{ background: "#e0e0e0" }}>
                    <TableCell sx={{ minWidth: 200, fontWeight: "bold" }}>
                      Supply Name
                    </TableCell>
                    <TableCell sx={{ minWidth: 150, fontWeight: "bold" }}>
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {suppliesProvider.map((data) => (
                    <Row key={data.id} data={data} />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[3, 5, 10]}
              component="div"
              count={totalItems}
              rowsPerPage={pageSizeChild}
              page={pageChild}
              onPageChange={(e, newPage) => setPageChild(newPage)}
              onRowsPerPageChange={(e) => {
                setPageSizeChild(parseInt(e.target.value, 10));
                setPageChild(0);
              }}
            />
          </>
        )}
      </Box>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity="success"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <ConfirmDialog
        open={openConfirm}
        title="Delete Supply"
        description="Are you sure you want to delete this supply? This action cannot be undone."
        confirmText="Delete"
        cancelText="Cancel"
        onConfirm={() => {
          if (pendingDeleteId) handleDelete(pendingDeleteId);
        }}
        onCancel={() => {
          setOpenConfirm(false);
          setPendingDeleteId(null);
        }}
      />
    </>
  );
};
